export enum EStatusLinkManagement {
  Detection = '0',
  ClientReview = '1',
  Enforcement = '2',
  Resolved = '3',
  Archived = '4',
  Pending = '5',
}

export enum EStatusLinkManagementValue {
  Detection = 'Detection',
  ClientReview = 'Client Review',
  Enforcement = 'Enforcement',
  Resolved = 'Resolved',
  Archived = 'Archived',
  Pending = 'Pending',
}

export enum EIdentifiedTypeLinkManagement {
  AtSource = '0',
  SearchEngine = '1',
  SubmittedManually = '2',
}

export enum EIdentifiedTypeLinkManagementValue {
  AtSource = 'At Source',
  SearchEngine = 'Search Engine',
  SubmittedManually = ' Submitted Manually',
}

export enum EPriorityLinkManagement {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  NoActionNeeded = 'noActionNeeded',
}

export enum EPriorityLinkManagementValue {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  NoActionNeeded = 'No Action Needed',
}

export enum EEditableType {
  SourceType,
  Status,
  Priority,
}

export enum ELinkPriorityValues {
  LOW_MIN = 0.66,
  LOW_MAX = 1,
  MEDIUM_MIN = 0.51,
  MEDIUM_MAX = 0.65,
  HIGH_MIN = 0,
  HIGH_MAX = 0.5,
  NoActionNeeded = 2,
}
